import { TeamScreen } from "@/components/team/TeamScreen";

export function TeamPage() {
  return <TeamScreen />;
}
